const searchbars = document.querySelectorAll('.uke-block-searchbar');


for (let searchbar of searchbars) {
    let placeholder = searchbar.querySelector('.placeholder');
    let input = searchbar.querySelector('.search-field');


    if (placeholder && input) {
        input.addEventListener('focus', function () {
            if (placeholder) {
                placeholder.remove();
            }

            if (!searchbar.classList.contains('focus')) {
                let overlay = document.createElement('div');
                overlay.classList.add('searchbar-overlay');
                searchbar.parentElement.appendChild(overlay);
                searchbar.classList.add('focus');
            }

            function waitForMousedown() {
                if (searchbar.classList.contains('focus') && searchbar.parentElement.querySelector('.uke-block-searchbar:hover') == null) {
                    searchbar.parentElement.querySelector('.searchbar-overlay').remove();
                    searchbar.classList.remove('focus');
                    window.removeEventListener('mousedown', waitForMousedown);
                    window.removeEventListener('keydown', waitForRightKeyPress);
                }
            }

            function waitForRightKeyPress(event) {
                if (event.isComposing || event.keyCode === 229) {
                    return;
                }
                if (event.code === 'Escape') {
                    searchbar.parentElement.querySelector('.searchbar-overlay').remove();
                    searchbar.classList.remove('focus');
                    window.removeEventListener('keydown', waitForRightKeyPress);
                    window.removeEventListener('mousedown', waitForMousedown);
                }
                if (event.code === 'Tab') {
                    let currentlyActive = document.activeElement;
                    if (!currentlyActive.classList.contains('search-field') ||  (currentlyActive.classList.contains('search-field') && event.shiftKey === true)) {
                        searchbar.parentElement.querySelector('.searchbar-overlay').remove();
                        searchbar.classList.remove('focus');
                        window.removeEventListener('keydown', waitForRightKeyPress);
                        window.removeEventListener('mousedown', waitForMousedown);
                    }

                }

            }

            window.addEventListener('mousedown', waitForMousedown);
            window.addEventListener('keydown', waitForRightKeyPress);

        });


        // input.addEventListener('blur', function (){
        //     searchbar.parentElement.querySelector('.searchbar-overlay').remove();
        //     searchbar.classList.remove('focus');
        // });
    }
}